/**
 *  获取年月日
 *  @param {string} i 时间当前时间的第几天 可以是负数 
 * @return {string}   返回的时间字符串

*/
export const getCurrentTime = (i) => {
  var date
  if (i) {
    date = new Date(Date.parse(new Date()) + i * 24 * 3600 * 1000);
  } else {
    date = new Date();
  }
  var month = parseInt(date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}

/**
 * 时间戳格式化函数
 * @param {int} now 要格式化的时间 默认为当前时间
 * @return {string}   格式化的时间字符串
 */
export const transferDate = (now) => {

  var year = now.getFullYear();  //取得4位数的年份
  var month = now.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
  var date = now.getDate();      //返回日期月份中的天数（1到31）
  var hour = now.getHours();     //返回日期中的小时数（0到23）
  var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
  if (minute < 10) {
    minute = '0' + minute
  }
  if (month < 10) {
    month = '0' + month
  }
  if (date < 10) {
    date = '0' + date
  }
  if (hour < 10) {
    hour = '0' + hour
  }

  var second = now.getSeconds(); //返回日期中的秒数（0到59）
  if (second < 10) {
    second = '0' + second
  }
  // if(format == '')
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}

/**
 * 日期后的天数
 * @param {int} now 传入的时间 
 *  @param {int} num 传入的时间 
 * @return {string}   转换后时间字符串
 */
export const lastFewDays = (now, num) => {

  if (!now) return ''
  var date = new Date(Date.parse(new Date(now)) + num * 24 * 3600 * 1000);
  var year = date.getFullYear();  //取得4位数的年份
  var month = date.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
  var day = date.getDate();      //返回日期月份中的天数（1到31）
  var hour = date.getHours();     //返回日期中的小时数（0到23）
  var minute = date.getMinutes(); //返回日期中的分钟数（0到59）
  if (minute < 10) {
    minute = '0' + minute
  }
  if (month < 10) {
    month = '0' + month
  }

  var second = date.getSeconds(); //返回日期中的秒数（0到59）
  if (second < 10) {
    second = '0' + second
  }
  // if(format == '')
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

export function getDate() {
  let time = ''
  let now = new Date();
  let year = now.getFullYear(); //得到年份
  let month = now.getMonth() + 1;//得到月份
  let date = now.getDate();//得到日期
  var hour = now.getHours();     //返回日期中的小时数（0到23）
  var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
  var second = now.getSeconds(); //返回日期中的秒数（0到59）
  if (minute < 10) {
    minute = '0' + minute
  }
  if (date < 10) {
    date = '0' + date
  }
  if (month < 10) {
    month = '0' + month
  }
  if (second < 10) {
    second = '0' + second
  }
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}
// 当前日期 timer.format 例:yyyy-mm-dd==年-月-日
export const specifiedFormatDate = (timer) => {
  var date = new Date();
  if (timer.date) {
    var date = new Date(timer.date);
  }
  var month = parseInt(date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (timer.format) {
    return timer.format.replace('yyyy', date.getFullYear()).replace('mm', month).replace('dd', day);
  }
  return date.getFullYear() + '-' + month + '-' + day;
}

// 当前月份第一天
export const getCurrentMonthFirst = () => {
  var date = new Date();
  date.setDate(1);
  var month = parseInt(date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}

// 当前月份最后一天
export const getCurrentMonthLast = () => {
  var date = new Date();
  var currentMonth = date.getMonth();
  var nextMonth = ++currentMonth;
  var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
  var oneDay = 1000 * 60 * 60 * 24;
  var lastTime = new Date(nextMonthFirstDay - oneDay);
  var month = parseInt(lastTime.getMonth() + 1);
  var day = lastTime.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}

// 当前日期前1天
export const getCurrentDayBefo = (date) => { //获取前一天日期
  let time = ''
  if (date) {
    time = new Date(date).getTime() - 24 * 60 * 60 * 1000;
  } else {
    time = new Date().getTime() - 24 * 60 * 60 * 1000;
  }
  let yesterday = new Date(time);
  let month = yesterday.getMonth();
  let day = yesterday.getDate();
  return yesterday = yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1 >= 10 ? (yesterday.getMonth() + 1) : "0" + (yesterday.getMonth() + 1)) + "-" + (yesterday.getDate() > 10 ? (yesterday.getDate()) : "0" + (yesterday.getDate()));
}


/**
 *  多一个月
 * @param {int} now 传入的时间 
 *  @param {int} num 传入的时间 
 * @return {string}   转换后时间字符串
 */
export const oneMoreMonth = (now) => {
  var date = new Date(now); // Now
  date.setDate(date.getDate() + 30); // Set now + 30 days as the new date
  var year = date.getFullYear();  //取得4位数的年份
  var month = date.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
  var day = date.getDate();      //返回日期月份中的天数（1到31）
  var hour = date.getHours();     //返回日期中的小时数（0到23）
  var minute = date.getMinutes(); //返回日期中的分钟数（0到59）
  var second = date.getSeconds(); //返回日期中的秒数（0到59）
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (second < 10) {
    second = '0' + second
  }
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}
/**
 *  少一个月
 * @param {int} now 传入的时间 
 *  @param {int} num 传入的时间 
 * @return {string}   转换后时间字符串
 */
export const lessThanAMonth = (now) => {
  var date = new Date(now); // Now
  date.setDate(date.getDate() - 30); // Set now + 30 days as the new date
  var year = date.getFullYear();  //取得4位数的年份
  var month = date.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
  var day = date.getDate();      //返回日期月份中的天数（1到31）
  var hour = date.getHours();     //返回日期中的小时数（0到23）
  var minute = date.getMinutes(); //返回日期中的分钟数（0到59）
  var second = date.getSeconds(); //返回日期中的秒数（0到59）
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (second < 10) {
    second = '0' + second
  }
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

/**
 *  时间差
 * @param {int} now 传入的时间 
 *  @param {int} num 传入的时间 
 * @return {string}   转换后时间字符串
 */
export const timeDifference = (now, num) => {
  var current = new Date(); // Now
  var date = new Date(now); // Now
  date.setDate(date.getDate() + num); // 
  let diffDateMsec,
    dateMsec_1 = Date.parse(date),
    dateMsec_2 = Date.parse(current)
  // 将两个日期都转换为毫秒格式，然后相减

  diffDateMsec = Math.abs(dateMsec_2 - dateMsec_1) // 取相差毫秒数的绝对值

  return Math.floor(diffDateMsec / (1000 * 3600 * 24)) // 向下取整相差的天数

}

